import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SearchResponse } from '../models/search.models';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private http = inject(HttpClient);
  private readonly API_URL = `${environment.apiUrl}/search`;

  /** Глобальний пошук у межах прав поточного юзера (scope на беку за ManagementRole). */
  search(query: string): Observable<SearchResponse> {
    return this.http.get<SearchResponse>(this.API_URL, {
      params: new HttpParams().set('q', query),
    });
  }
}
